import { Theme, useMediaQuery } from '@mui/material';
import { ReactNode } from 'react';
import { useStyles } from './Content.styles';

interface Props {
  children: ReactNode;
}

export function Content({ children }: Props) {
  const isMobileView = useMediaQuery((theme: Theme) => theme.breakpoints.down('lg'));
  const classes = useStyles();

  return (
    <main
      className={classes.content}
      style={{
        width: isMobileView ? '80%' : '100%',
        padding: isMobileView ? 10 : 24,
      }}
    >
      <div className={classes.toolbar} />
      {children}
    </main>
  );
}
